/*eslint-disable */
import { useContext, useState, useEffect } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import GlobalContext from '../../../contexts/index';
import useSort from '../../../hooks/useSort';
import Filter from '../../Filter';
import { useNavigate } from 'react-router-dom';
import globalTranslating from '../../../translate.json';
import surveyTestTranslating from '../translate.json';
import SnackBar from 'components/SnackBar';
import { useParams } from 'react-router-dom';
import useFetchData from 'hooks/useFetchData';
// import './styles.scss';

const SurveySummeryTexts = () => {
  const translating = { ...globalTranslating, ...surveyTestTranslating };
  const { id: surveyMeasuresType } = useParams();
  const navigate = useNavigate();
  const { setLink } = useContext(GlobalContext);
  const [filteredSurveymeasures, setFilteredSurveymeasures] = useState([]);
  const [filteredTexts, setFilteredTexts] = useState([]);
  const [showSnackbar, setShowSnakbar] = useState(false);
  const { data: textsData, loading } = useFetchData('survey-text');

  useEffect(() => {
    if (textsData?.length) setFilteredTexts(textsData);
  }, [textsData]);

  const onFilter = (filteredData) => {
    setFilteredTexts(filteredData);
  };

  const onResetFilters = () => {
    setFilteredTexts(surveyLabData);
  };

  const { showFilters, toggle } = useSort();

  const tableHeaders = [
    'textId',
    translating.text,
    translating.category,
    translating.subCategory
  ];

  const columns = [
    { value: 'textId' },
    { value: 'text', bold: true },
    { value: 'category' },
    { value: 'subCategory' }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['textId', 'text', 'category']
    }
  ];

  return (
    <div className="survey-measures">
      <ListHeader
        title={translating[surveyMeasuresType]}
        // newItem={{ handleClick: () => setLink('d2') }}
      ></ListHeader>
      {showFilters && (
        <Filter
          fields={sortFields}
          data={textsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="survey-measures-wrapper-table">
        {filteredTexts && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredTexts}
            pagination={true}
            handleRowClick={(id) => {
              navigate(`/survey/texts/${id}`);
            }}
          ></TablePagination>
        )}
      </div>
      {/* {showSnackbar && (
                <SnackBar msg={'מדד נוסף'} handleClose={() => setShowSnakbar(false)}></SnackBar>
            )} */}
    </div>
  );
};

export default SurveySummeryTexts;
